export function mapInputsToAddressEE({
	addressLine1,
	addressLine2,
	district,
	municipality,
	county,
}) {
	const parts = [
		addressLine1,
		addressLine2,
		district,
		municipality,
		county,
	].filter(Boolean);

	return parts.join(', ');
}
